import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import GenerateKeyForm from './GenerateKeyForm';
import { useAppSelector, useAppDispatch } from '../../../hooks/redux/hooks';
import { apiKeyState } from '../apiKeySlice';

const GenerateKeyModal = () => {
    const { createdKey } = useAppSelector(apiKeyState);
    const [show, setShow] = useState(false);
    const dispatch = useAppDispatch();
    const handleClose = () => setShow(false);

    const handleShow = () => {
        setShow(true)
    };

    const { createdKey: {isLoading} } = useAppSelector(apiKeyState);

    useEffect(() => {
        if (createdKey.isSuccess) {
            handleClose();
        }
    }, [createdKey, dispatch]);


    return (
        <>
            <Button onClick={handleShow}> Create secret Key </Button>
            <Modal centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Create API key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <GenerateKeyForm handleClose={handleClose}/>
                </Modal.Body>
                {!isLoading && <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button form='generateKey-form' variant="primary" type="submit">
                        Create
                    </Button>
                </Modal.Footer>}
            </Modal>
        </>

    )
}

export default GenerateKeyModal